import * as PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import AppConfig from '../../config';
import { t } from '../../lang';
import TelegramWebApiService from '../../services/TelegramWebApiService';
import TypesService from '../../services/TypesService';
import HeaderBackButton from './HeaderBackButton';
import PageHeaderBar from './PageHeaderBar';
import PageTitleBar from './PageTitleBar';
import PageToolsBar from './PageToolsBar';

import './PageHeader.scss';

const { routes } = AppConfig;

const PageHeader = ({
	className = '',
	header = '',
	subheader = '',
	icon = null,
	iconLabel = null,
	collapsed = false,
	searchValue = '',
	updateSearchValue = null,
}) => {
	const [pageHeaderBackgroundHeight, setPageHeaderBackgroundHeight] = useState(0);
	const [scrollPosition, setScrollPosition] = useState(0);
	const [pageTitleBarHeight, setPageTitleBarHeight] = useState(0);

	const location = useLocation();

	const isItTelegram = useSelector(state => state.app.isItTelegram);

	const handleScroll = e => {
		const pageHeaderElements = [
			document.getElementsByClassName('PageHeader__background')[0],
			document.getElementsByClassName('PageHeaderBar')[0],
			document.getElementsByClassName('PageTitleBar')[0],
			document.getElementsByClassName('PageToolsBar')[0],
		];

		if (pageHeaderElements.some(element => e.target.contains(element))) {
			setScrollPosition(e.target.scrollTop);
		}
	};

	useEffect(() => {
		document.addEventListener('scroll', handleScroll, true);

		return () => {
			document.removeEventListener('scroll', handleScroll);
		};
	}, []);

	useEffect(() => {
		const brouserTopIndent = getComputedStyle(document.documentElement).getPropertyValue('--top-indent');
		const telegramTopIndent = isItTelegram && TelegramWebApiService.TelegramWebApi?.safeAreaInset?.top;
		const topIndent = telegramTopIndent || brouserTopIndent || 16;
		const pageHeaderBarHeight = document.getElementsByClassName('PageHeaderBar')[0]?.offsetHeight || 0;
		const pageToolsBarHeight = document.getElementsByClassName('PageToolsBar')[0]?.offsetHeight || 0;
		setPageHeaderBackgroundHeight(pageHeaderBarHeight + pageToolsBarHeight + topIndent + 8);

		const pageTitleBarHeight = document.getElementsByClassName('PageTitleBar')[0]?.offsetHeight || 0;
		setPageTitleBarHeight(pageTitleBarHeight);
	}, [className, header, subheader, icon, scrollPosition]);

	const showToolsBar = updateSearchValue; // ВСЕ ЧТО СВЯЗАНО С PageToolsBar ПОМЕНЯТЬ КОГДА БУДУТ ЗАДАЧИ СВЯЗАННЫЕ С НИМ

	const pageTitleBarScrolled = pageTitleBarHeight + 16 < scrollPosition;
	const pageHeaderBoxClassName = `${className}${collapsed || pageTitleBarScrolled ? ' PageTitleBoxVisible' : ''}`;
	const pageTitleBarClassName = `${className}${collapsed || pageTitleBarScrolled ? ' PageTitleBarHidden' : ''}`;

	const headerNode = typeof header === 'string' ? t(header) : header;
	const subheaderNode = typeof subheader === 'string' ? t(subheader) : subheader;

	const routesForBackButton = Object.values(routes).filter(route => !TypesService.BackButtonExceptions.includes(route));
	const needBackButtoninRoute = !isItTelegram && routesForBackButton.includes(location.pathname);

	return (
		<>
			{(collapsed || pageTitleBarScrolled) && (
				<div className='PageHeader__background' style={{ height: pageHeaderBackgroundHeight }}></div>
			)}
			{(header || subheader || icon || needBackButtoninRoute) && (
				<>
					<PageHeaderBar
						className={pageHeaderBoxClassName}
						header={headerNode}
						subheader={subheaderNode}
						icon={icon}
						iconLabel={iconLabel}
						leftElement={needBackButtoninRoute && <HeaderBackButton />}
					/>
					{(header || subheader || icon) && !collapsed && (
						<PageTitleBar
							className={pageTitleBarClassName}
							header={headerNode}
							subheader={subheaderNode}
							icon={icon}
							iconLabel={iconLabel}
						/>
					)}
				</>
			)}
			{showToolsBar && <PageToolsBar searchValue={searchValue} updateSearchValue={updateSearchValue} />}
		</>
	);
};

PageHeader.propTypes = {
	className: PropTypes.string,
	header: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	subheader: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	iconLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	searchValue: PropTypes.string,
	updateSearchValue: PropTypes.func,
};

export default PageHeader;
